import {
  UPDATE_CONFIG,
  UPDATE_ISCOPY,
  UPDATE_ADD_TO_BUNDLE_DISABLED,
  SET_CONFIG,
} from './actionTypes';
import { createAction } from '../utils/createAction';

export const updateConfigurationId = createAction(UPDATE_CONFIG, 'configurationId');

export const updateIsCopy = createAction(UPDATE_ISCOPY, 'isCopy');

export const updateAddToBundleDisabled = (payload) => ({
  type: UPDATE_ADD_TO_BUNDLE_DISABLED,
  payload,
});

export const setConfig = (settings) => (dispatch) => {
  dispatch({
    type: SET_CONFIG,
    payload: settings,
  });
};
